import { Component, ElementRef, OnInit, DestroyRef, inject, signal } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { Devices } from '@app/_models/devices';
import { AuthenticationService } from '@app/_services';
import { DeviceService } from '@app/_services/device.service';
import { faCamera } from '@fortawesome/free-solid-svg-icons';
import { ToastrService } from 'ngx-toastr';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-operate-device',
    templateUrl: './operate-device.component.html',
    styleUrls: ['./operate-device.component.css'],
    standalone: false
})
export class OperateDeviceComponent implements OnInit {

  form!: FormGroup;
  devices = signal<Devices[]>([]);
  property_id = signal<any>(null);
  faCamera = faCamera;
  cameraVisible = signal(false);
  selectedTab = signal<'gates' | 'devices'>('gates');
  devicesTabOpened = signal(false);

  private destroyRef = inject(DestroyRef);

  constructor(private deviceService: DeviceService,
    private authenticationService: AuthenticationService,
    private route: ActivatedRoute,
    private toastr: ToastrService, private el: ElementRef) { }

  ngOnInit(): void {
    this.route.paramMap
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((params: Params) => {
        this.property_id.set(params.get('propertyid'));
      });

    this.deviceService.getDevices(this.property_id())
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (data) => {
          this.devices.set(data);
        }
      });
  }

  selectDevicesTab(): void {
    this.devicesTabOpened.set(true);
    this.selectedTab.set('devices');
  }

  displayCamera(deviceid: number) {
    let divelm = "div.camera-preview-" + deviceid;
    let camelm = this.el.nativeElement.querySelector(divelm);

    if (this.cameraVisible()) {
      camelm.classList.add("d-none");
      this.cameraVisible.set(false);
    } else {
      camelm.classList.remove("d-none");
      this.cameraVisible.set(true);
    }

    let swielm = "div.main-switch-" + deviceid;
    let mainswitch = this.el.nativeElement.querySelector(swielm);

    if (this.cameraVisible()) {
      mainswitch.classList.add("d-camera-mb");
    } else {
      mainswitch.classList.remove("d-camera-mb");
    }
  }

  toggleDevice(event: any, devicename: any, deviceid: any) {
    const request = {
      "accessby": this.authenticationService.currentUserValue!.username,
      "devicename": devicename,
      "accessmethod": "public_ip"
    };

    if (event.target.checked === true) {
      this.deviceService.operateDevice(request)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: (data) => {
            this.toastr.success(data.message, 'Success');
          },
          error: () => {
            this.toastr.error('Something went wrong.','Error');
          }
        });

      setTimeout(() => {
        const obj = document.getElementById(deviceid) as HTMLInputElement;
        if (obj) {
          obj.checked = false;
        }
      }, 10000);
    }
  }

}
